
import { IBindMobile, UserApiSerivce } from '@/api/user';
import { defineComponent, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/store/modules/user';
import { ElMessage } from 'element-plus';
import { CloseBold } from '@element-plus/icons';
import { FILESERVICE } from '@/config/defaultSetting';

export default defineComponent({
  name: 'BindMobile',
  components: {
    CloseBold,
  },
  props: {
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['closeDia'],
  setup(prop, context) {
    const userStore = useUserStore();
    const route = useRoute();
    const ruleForm = ref();
    const bindMobileData = reactive({
      verifyCode: '',
      mobile: '',
    });
    const countDown = ref(60);
    const countDownHidden = ref(false);
    const rules = reactive({
      mobile: [{ validator: validateMobile, trigger: 'blur' }],
      verifyCode: [{ validator: validateCode, trigger: 'blur' }],
    });
    const checked = ref(false);

    function onClose() {
      if (route.name === 'login') {
        userStore.resetState();
      }
      context.emit('closeDia', undefined);
    }

    function validateMobile(
      rule: any,
      value: string,
      callback: (arg0?: Error | undefined) => void
    ) {
      if (
        !/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(
          value
        )
      ) {
        callback(new Error('请输入正确手机号'));
      } else {
        callback();
      }
    }

    function validateCode(
      rule: any,
      value: string,
      callback: (arg0?: Error | undefined) => void
    ) {
      if (!bindMobileData.mobile) {
        ruleForm.value.validateField('mobile');
      }
      callback();
    }

    const getCode = async () => {
      if (countDown.value === 60 && bindMobileData.mobile) {
        try {
          await UserApiSerivce.sessioneCode(bindMobileData.mobile);
        } catch (error) {
          throw new Error(error as any);
        }
        countDownHidden.value = true;
        let codeTime = setInterval(() => {
          countDown.value--;
          if (countDown.value < 1) {
            clearInterval(codeTime);
            countDown.value = 60;
            countDownHidden.value = false;
          }
        }, 1000);
      } else {
        ruleForm.value.validateField('mobile');
      }
    };

    const onBindMobile = () => {
      let initData: IBindMobile = {
        verifyCode: bindMobileData.verifyCode,
        mobile: bindMobileData.mobile,
      };
      ruleForm.value.validate(async (valid: any) => {
        if (valid) {
          UserApiSerivce.bindMobile(initData)
            .then(() => {
              ElMessage.success({
                message: '绑定成功',
                type: 'success',
              });
              onClose();
            })
            .catch((err) => {
              throw new Error(err);
            });
        }
      });
      return;
    };

    const onReadingProtocol = () => {
      let url = `${process.env.VUE_APP_TMS_SERVERS_URL}app-bulletin/agreement-4pl.html`;
      let name = '_blank';
      let iWidth = 500; // 弹出窗口的宽度;
      let iHeight = 600; //  弹出窗口的高度;
      let iTop = (window.screen.availHeight - 30 - iHeight) / 2; //  获得窗口的垂直位置
      let iLeft = (window.screen.availWidth - 10 - iWidth) / 2; //  获得窗口的水平位置
      let specs =
        'height=' +
        iHeight +
        ',,innerHeight=' +
        iHeight +
        ',width=' +
        iWidth +
        ',innerWidth=' +
        iWidth +
        ',top=' +
        iTop +
        ',left=' +
        iLeft;
      window.open(url, name, specs);
    };

    const onChange = () => {
      checked.value = !checked.value;
    };

    const getUserInformation = async () => {
      try {
        let result = await UserApiSerivce.getUserInformation();
        bindMobileData.mobile = result.mobile;
      } catch (error) {
        throw new Error(error as any);
      }
    };
    getUserInformation();

    return {
      bindMobileData,
      getCode,
      countDown,
      countDownHidden,
      ruleForm,
      onBindMobile,
      onClose,
      onReadingProtocol,
      onChange,
      checked,
      rules,
      FILESERVICE,
      prop,
    };
  },
});
